import {object, string} from "yup";

export default object().shape({
  principalName: string().required().max(100).default(''),
  password: string().required().max(50).default('')
});